import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingOverlay } from './shared/ui/loading-overlay/loading-overlay';
import { ConnectionStatus } from './shared/ui/connection-status/connection-status';
import { NotificationCenter } from './shared/ui/notification-center/notification-center';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingOverlay, NotificationCenter, ConnectionStatus],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
